// components/FeaturesList.js
import React from 'react';
import FeatureCard from './FeatureCard';

const FeaturesList = ({ onNavigate, onAddToCart }) => {
  const features = [
    {
      id: '02',
      title: '学单词-读单词-单词填空-单词音节拆分-单词拼读-单词默写',
      subtitle: '学习完整链路，从学到考一步到位。',
      popularity: '一周内300+人下单',
      mockupImage: '/api/placeholder/200/400',
      description: 'Complete vocabulary learning system'
    },
    {
      id: '03',
      title: '自然拼读拆解',
      subtitle: '拼-读-默写-拆分-真题例例句运用',
      popularity: '2人评价：功能很不错',
      mockupImage: '/api/placeholder/200/400',
      description: 'Natural phonics breakdown system'
    },
    {
      id: '04',
      title: '长难词拆分词根词缀长单词描边短单词',
      syllables: ['ɑː', 'ftə', 'nuː', 'n'],
      mockupImage: '/api/placeholder/200/400',
      description: 'Word root and syllable analysis'
    },
    {
      id: '05',
      title: '所有单词都有针对的专项练习',
      subtitle: '多维度练习掌握单词',
      mockupImage: '/api/placeholder/200/400',
      description: 'Targeted practice exercises'
    },
    {
      id: '06',
      title: '音标雪梨老师真人教学',
      subtitle: '港中文翻译硕士带你学口型舌位',
      popularity: '三天内400+人加购',
      phoneticImages: ['[ɪ]', '[e]', '[æ]', '[ɜː]'],
      mockupImage: '/api/placeholder/200/400',
      description: 'Professional phonetics instruction'
    },
    {
      id: '07',
      title: 'AI老师根据艾宾浩斯记忆曲线给孩子定制学习计划',
      subtitle: '学到哪？学多少？怎么复习？都安排好，省爸省妈。',
      mockupImage: '/api/placeholder/200/400',
      description: 'AI-powered learning schedule'
    },
    {
      id: '08',
      title: '每个单词，每一个例句都有口语测评',
      subtitle: '随时随地培养口语输出环境',
      gift: '买享1件礼：【赠品】雪梨...',
      mockupImage: '/api/placeholder/200/400',
      description: 'Speaking assessment for every word'
    },
    {
      id: '09',
      title: '发音 流利度 完整度多维评分',
      subtitle: '实时反馈学习成果',
      mockupImage: '/api/placeholder/200/400',
      description: 'Multi-dimensional pronunciation scoring'
    },
    {
      id: '10',
      title: '雪梨老师王牌课程',
      subtitle: '自拼+音标2000+免费学',
      mockupImage: '/api/placeholder/200/400',
      description: 'Premium course content'
    },
    {
      id: '11',
      title: '嵌入AI 1对1练习',
      subtitle: '口语、写作、语法 定制专属学习计划',
      mockupImage: '/api/placeholder/200/400',
      description: 'AI-powered 1-on-1 practice'
    },
    {
      id: '12',
      title: '考前快速查缺补漏 还原学霸扫词学习法',
      subtitle: '快速 英选中 中选英 乱序过词 有的放矢转向训练',
      popularity: '一周内300+人下单',
      mockupImage: '/api/placeholder/200/400',
      description: 'Pre-exam review system'
    }
  ];

  return (
    <div className="features-list">
      {features.map((feature) => (
        <FeatureCard
          key={feature.id}
          feature={feature}
          onNavigate={onNavigate}
          onAddToCart={onAddToCart}
        />
      ))}
      
      <div className="related-products">
        <h3>看了又看</h3>
        <div className="product-cards">
          <div className="product-card orange">
            <h4>乐学同步单词</h4>
            <p>自然拼读 高效记单词神器</p>
            <div className="features-tags">
              <span>同步各地教材</span>
              <span>AI工具辅助学</span>
              <span>支持多人学习</span>
            </div>
            <div className="price">
              <span className="current-price">¥198</span>
              <span className="original-price">¥448</span>
              <span className="discount">限时下单立减250元</span>
            </div>
          </div>
          
          <div className="product-card green">
            <h4>雪梨老师来啦单词 拼读王</h4>
            <div className="features-tags">
              <span>同步各地教材</span>
              <span>手机平板学习机全</span>
              <span>支持多人学习</span>
              <span>嵌入ai老师辅助学习</span>
            </div>
            <div className="trial-info">
              <span className="trial-badge">1年体验版</span>
              <span>找客服 试用 满意下单</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="bottom-notice">
        <p>此商品不支持在当前地区销售</p>
        <button className="change-location">更改地址</button>
      </div>
      
      <div className="bottom-actions">
        <button className="store-btn">🏪 店铺</button>
        <button className="service-btn">🎧 客服</button>
        <button className="rating-btn">⭐ 1718</button>
        <button className="add-to-cart-btn" onClick={() => onAddToCart({ name: 'English Learning App' })}>
          加入购物车
        </button>
      </div>
    </div>
  );
};

export default FeaturesList;